// import { useNavigate } from "react-router-dom"
// import { useAuth } from '../../context/AuthContext'
import './headertwo.scss'
// import { headerUserData } from "../../interface/interfaces"
// import { useEffect, useState } from "react"
// import { NavLink } from 'react-router-dom'
// import UserEntry from '../UserEntry/UserEntrySection'
// import { useUser } from '../../context/UserContext'
// import HeaderTwoMenu from '../HeaderTwoMenu/HeaderTwoMenu'
import Header from '../Header/HeaderSection'

// const HeaderTwo = () => {
//     // const navigate = useNavigate()
//     const { isLoggedIn } = useAuth()
//     const { currentUser, reloadUser } = useUser()
//     const [userEntry, setUserEntry] = useState(false)
//     const [userData, setUserData] = useState<headerUserData | null>(null)
//     const [menuToggle, setMenuToggle] = useState(false)


//     useEffect(() => {
//         var logInStatus = isLoggedIn()

//         if (logInStatus && currentUser) {

//             let inits = `${(currentUser.first_name[0]).toUpperCase()}${(currentUser.last_name[0]).toUpperCase()}`

//             setUserData(
//                 {
//                     initials: inits,
//                     userImg: currentUser.image ? currentUser.image : '',
//                     isUserImage: currentUser.image ? true : false,
//                     isLoggedIn: logInStatus
//                 }
//             )

//         }
//     }, [currentUser, isLoggedIn])


//     useEffect(() => {
//         const func = async () => {
//             await reloadUser()
//         }

//         func()
//         // eslint-disable-next-line
//     }, [])


//     const openUserEntry = () => {
//         setUserEntry(true)
//     }

//     const handleToggle =()=>{
//         setMenuToggle((prev)=> !prev)
//     }

//     return (
//         <div className="headerTwo">
//             <div className='headerContent'>

//                 <div className='upperHeader'>

//                     <NavLink to={'/'}>
//                         <div className='logoArea'>
//                             <div className='icon logo_initials'></div>
//                             <div className='icon logo_name'></div>
//                         </div>
//                     </NavLink>


//                     <div className="nav">

//                         <NavLink to={'/'} className={({ isActive }) => isActive ? "activeNav" : ""}>
//                             <div className="eachnav">
//                                 <div className="text">Home</div>
//                                 <div className="underline"></div>
//                             </div>
//                         </NavLink>



//                          <NavLink to={'/account'} className={({ isActive }) => isActive ? "activeNav" : ""}>
//                             <div className="eachnav">
//                                 <div className="text">Account</div>
//                                 <div className="underline"></div>
//                             </div>
//                         </NavLink>



//                         <NavLink to={'/coupons'} className={({ isActive }) => isActive ? "activeNav" : ""}>
//                             <div className="eachnav">
//                                 <div className="text">Coupon</div>
//                                 <div className="underline"></div>
//                             </div>
//                         </NavLink>


//                         <NavLink to={'/products'} className={({ isActive }) => isActive ? "activeNav" : ""}>
//                             <div className="eachnav">
//                                 <div className="text">Shop</div>
//                                 <div className="underline"></div>
//                             </div>
//                         </NavLink>


//                         {/* <div className="eachnav">
//                             <div className="text">Shop</div>
//                             <div className="underline"></div>
//                         </div>

//                         <div className="eachnav">
//                             <div className="text">Hot offers</div>
//                             <div className="underline"></div>
//                         </div>

//                         <div className="eachnav">
//                             <div className="text">Pages</div>
//                             <div className="underline"></div>
//                         </div>

//                         <div className="eachnav">
//                             <div className="text">Contact us</div>
//                             <div className="underline"></div>
//                         </div> */}

//                     </div>

//                     <div className="button_pack">

//                         {userData && (<>

//                             {userData.isLoggedIn && (


//                                 <NavLink to={'/account/profile'}>
//                                     <div className='myaccount'>

//                                         {userData.isUserImage && (<img className='userImg' src={userData.userImg} alt='userImg'></img>)}

//                                         {!userData.isUserImage && (<div className='userInitials'>
//                                             {userData.initials}
//                                         </div>)}

//                                     </div>
//                                 </NavLink>
//                             )}


//                             {!userData.isLoggedIn && (
//                               <div className='userentry_flex'>

//                                 <div className='action_flex btns'>
//                                     <NavLink to={'/signin'}> <button className='action open'>Sign In</button></NavLink>
//                                     <NavLink to={'/signup'}><button className='action full'>Create Account</button></NavLink>
//                                 </div>


//                                 <div className='svgicon userentry' onClick={openUserEntry}>
//                                     <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                         <g clip-path="url(#clip0_193_2)">
//                                             <path fill-rule="evenodd" clip-rule="evenodd" d="M10 10.6001C12.7625 10.6001 15 8.3626 15 5.6001C15 2.8376 12.7625 0.600098 10 0.600098C7.2375 0.600098 5 2.8376 5 5.6001C5 8.3626 7.2375 10.6001 10 10.6001ZM10 12.1001C6.6625 12.1001 0 13.7751 0 17.1001V18.3501C0 19.0376 0.5625 19.6001 1.25 19.6001H18.75C19.4375 19.6001 20 19.0376 20 18.3501V17.1001C20 13.7751 13.3375 12.1001 10 12.1001Z" fill="white" />
//                                         </g>
//                                         <defs>
//                                             <clipPath id="clip0_193_2">
//                                                 <rect width="20" height="20" fill="white" />
//                                             </clipPath>
//                                         </defs>
//                                     </svg>

//                                 </div>


//                                 {/* <User2Icon size={28} color={'#fff'} className='' onClick={openUserEntry}></User2Icon> */}
//                             </div>
//                           )}

//                         </>)}




//                     </div>

//                     <div className='menuIcon' onClick={handleToggle}>
//                         <div className='line'></div>
//                         <div className='line'></div>
//                         <div className='line'></div>
//                     </div>


//                 </div>

//             </div>
//             <UserEntry toggle={userEntry} setToggle={setUserEntry}></UserEntry>

//             <HeaderTwoMenu toggle={menuToggle} setToggle={setMenuToggle}></HeaderTwoMenu>

//             <div className='navpack'>

//             </div>

//         </div>
//     )
// }

// export default HeaderTwo




const HeaderTwo = () => {
//   const { isLoggedIn } = useAuth();
  return <Header></Header>
};

export default HeaderTwo